export default "__VITE_ASSET__8bbaffd1__"